import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { fetchContactUs, updateContactUs, deleteContactUs } from "./ContactUsAPI"

const initialState = {
    data: [],
    loading: false,
    error: null,
}

export const fetchContactUsAsync = createAsyncThunk("contactUs/fetch", async (_, { rejectWithValue }) => {
    try {
        return await fetchContactUs()
    } catch (error) {
        return rejectWithValue(error.message)
    }
})

export const updateContactUsAsync = createAsyncThunk("contactUs/update", async (contactData, { rejectWithValue }) => {
    try {
        return await updateContactUs(contactData)
    } catch (error) {
        return rejectWithValue(error.message)
    }
})

export const deleteContactUsAsync = createAsyncThunk("contactUs/delete", async (uuid, { rejectWithValue }) => {
    try {
        return await deleteContactUs(uuid)
    } catch (error) {
        return rejectWithValue(error.message)
    }
})

const ContactUsSlice = createSlice({
    name: "contactUs",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Fetch cases
            .addCase(fetchContactUsAsync.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(fetchContactUsAsync.fulfilled, (state, action) => {
                state.loading = false
                state.data = action.payload
            })
            .addCase(fetchContactUsAsync.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload || "Something went wrong"
            })
            // Update cases
            .addCase(updateContactUsAsync.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(updateContactUsAsync.fulfilled, (state, action) => {
                state.loading = false
                // Update the specific contact in the data array
                const updatedContact = action.payload
                const index = state.data.findIndex((contact) => contact.uuid === updatedContact.uuid)
                if (index !== -1) {
                    state.data[index] = updatedContact
                }
            })
            .addCase(updateContactUsAsync.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload || "Failed to update contact"
            })
            // Delete cases
            .addCase(deleteContactUsAsync.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(deleteContactUsAsync.fulfilled, (state, action) => {
                state.loading = false
                // Remove the deleted contact from the data array
                // Assuming the action.meta.arg contains the UUID that was deleted
                const deletedUuid = action.meta.arg
                state.data = state.data.filter((contact) => contact.uuid !== deletedUuid)
            })
            .addCase(deleteContactUsAsync.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload || "Failed to delete contact"
            })
    },
})

export const selectContactUs = (state) => state.contactUs.data
export const selectContactUsLoading = (state) => state.contactUs.loading
export const selectContactUsError = (state) => state.contactUs.error

export default ContactUsSlice.reducer
